import React from 'react';
import PropTypes from 'prop-types';
import Pagination from "semantic-ui-react/dist/es/addons/Pagination/Pagination.js";
import classNames from 'classnames';
import { getPageItemMarkup } from "./utils/getPageItemMarkup";
import { getNextItemMarkup } from "./utils/getNextItemMarkup";
import { getPreviousItemMarkup } from "./utils/getPreviousItemMarkup";
import { getBoundryRange } from "./utils/getBoundryRange";
import { getSiblingRange } from "./utils/getSiblingRange";
export var Component = function Component(_ref) {
  var activePage = _ref.activePage,
      isShowingPageNumbers = _ref.isShowingPageNumbers,
      onPageChange = _ref.onPageChange,
      startingPage = _ref.startingPage,
      totalPages = _ref.totalPages;
  return React.createElement(Pagination, {
    activePage: activePage,
    boundaryRange: getBoundryRange(isShowingPageNumbers),
    className: classNames({
      'has-page-numbers': isShowingPageNumbers
    }),
    defaultActivePage: typeof activePage === 'undefined' ? startingPage : undefined,
    firstItem: null,
    lastItem: null,
    nextItem: getNextItemMarkup(isShowingPageNumbers),
    onPageChange: onPageChange,
    pageItem: getPageItemMarkup(isShowingPageNumbers),
    prevItem: getPreviousItemMarkup(isShowingPageNumbers),
    secondary: true,
    siblingRange: getSiblingRange(isShowingPageNumbers),
    totalPages: totalPages
  });
};
Component.displayName = 'Pagination';
Component.defaultProps = {
  activePage: undefined,
  isShowingPageNumbers: false,
  onPageChange: Function.prototype,
  startingPage: 1
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  activePage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isShowingPageNumbers: PropTypes.bool,
  onPageChange: PropTypes.func,
  startingPage: PropTypes.number,
  totalPages: PropTypes.number.isRequired
} : {};